// 새 차트를 만들면 텅 비어보이지 않도록 자동으로 채워주는 튜토리얼 작업들.
// 색상은 무지개 톤으로, 각 작업명은 사용법 안내가 한 줄씩 이어지도록.

const TIPS = [
  { name: "① 환영합니다 — 작업을 클릭하면 우측 패널이 열려요",       color: "#ef4444", progress: 100 },
  { name: "② 패널에서 이름·담당자·진행률·기간을 바꿔보세요",         color: "#f97316", progress: 100 },
  { name: "③ 막대를 좌우로 끌면 기간이 통째로 옮겨집니다",            color: "#f59e0b", progress: 70 },
  { name: "④ 막대 끝을 잡고 늘리면 종료일만 바뀌어요",                color: "#16a34a", progress: 50 },
  { name: "⑤ '+ 새 작업' 으로 일정을 직접 추가할 수 있어요",          color: "#0ea5e9", progress: 25 },
  { name: "⑥ '작업 목록에서 가져오기' 로 백로그를 끌어오세요",        color: "#2563eb", progress: 10 },
  { name: "⑦ 상단 '기준일' 을 바꾸면 진척률 D-day가 갱신돼요",        color: "#8b5cf6", progress: 0 },
  { name: "⑧ 익숙해졌다면 이 작업들을 지우고 시작하세요",             color: "#ec4899", progress: 0 },
]

export function buildTutorialTasks() {
  const today = new Date()
  today.setHours(0, 0, 0, 0)

  const baseId = Date.now()
  const spanDays = 10
  const stepDays = 4

  return TIPS.map((tip, i) => {
    const start = new Date(today)
    start.setDate(start.getDate() + i * stepDays)
    const end = new Date(start)
    end.setDate(end.getDate() + spanDays - 1)

    return {
      id: `tutorial-${baseId}-${i}`,
      name: tip.name,
      color: tip.color,
      startDate: start,
      endDate: end,
      progress: tip.progress,
      assignee: null,
      type: "",
      dependencies: i === 0 ? [] : [`tutorial-${baseId}-${i - 1}`],
    }
  })
}
